import axios from 'axios';
import authHeader from './services/auth-header';

export const HTTP = axios.create({
  baseURL: `https://valgberegner-api.kl.dk`,
  headers: authHeader(),
});
